<template>
  <statistic-dialog
    class="statisticDialog"
    :visible.sync="dialogVisible"
    :title="$t('device.protocolStatistic')"
    width="80vw"
    noFooter
  >
    <div slot="content" class="statistic" @click.stop="closeParamSetting">
      <div class="tab">
        <span class="title">{{$t('device.chooseProtocol')}}</span>
        <li class="tab-item" v-for="item in protocolList" :key="item" :class="{active:activeProtocol==item}" @click="activeProtocol=item">{{item}}</li>
      </div>
      <device-param ref="param" :deviceInfo="protocolInfo" class="section section-param"></device-param>
      <div class="board">
        <div class="section status">
          <div style="display:flex;margin-top:15px;align-self:start" lass="title">
            <img slot="prefix" src="@/assets/img/shebei.png" style="width:18px;height:22px;" />
          <p style="margin-left:10px">{{$t('device.device_status')}}</p>
          </div>
          <div
            class="status"
            v-loading="deviceStatus.isLoading"
            element-loading-spinner="el-icon-loading"
          >
            <echart-ring class="status-chart" :data="deviceStatus.chartData" :total="deviceStatus.total" :dbCilck="true" :normalShow="false"></echart-ring>
            <div class="status-clause">
              <template v-for="(item,key) in deviceStatus.dic">
                <span class="item-name" :key="key + 'name'">
                  <i class="status-icon" :style="{'background-color': item.color}"></i>
                  {{item.name}}
                </span>
                <span class="item-value" :key="key + 'percent'">{{devicePercentData[key]}}</span>
                <span class="item-value" :key="key + 'value'">{{item.value}}</span>
              </template>
            </div>
          </div>
        </div>
        <div class="section energy" v-loading="energy.isLoading" element-loading-spinner="el-icon-loading">
        <el-date-picker
          class="date"
          type="date"
          :editable=false
          :clearable=false
          v-model="energy.date"
          @change="queryEnergyData"
        >
        </el-date-picker>
        <echart-line
          class="chart-energy"
          v-if="energy.chartData"
          :category="energy.chartData.category"
          :data="energy.chartData.data"
          unit="kW"
          unitX="H"
        ></echart-line>
      </div>
      </div>
      
    </div>
  </statistic-dialog>
</template>
<script>
import statisticDialog from '@/components/dialog'
import deviceParam from '@/components/param'
import echartRing from '@/components/echarts/ring'
import echartLine from '@/components/echarts/line'
import { i18n } from '@/i18n'
export default {
  components: {
    statisticDialog,
    deviceParam,
    echartRing,
    echartLine
  },
  props: {
    visible: {
      default: false
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      protocolList: [], // 协议类型列表
      activeProtocol: null, //当前选择协议
      // 设备状态数据
      deviceStatus: {
        dic: {
          'normalCount': {
            name: this.$t('statistic.normal'),
            color: '#66c676',
            value: 0
          },
          'offCount': {
            name: this.$t('statistic.offline'),
            color: '#d3d3d3',
            value: 0
          },
          'warningCount': {
            name: this.$t('statistic.warning'),
            color: '#ffd37c',
            value: 0
          },
          'faultCount': {
            name: this.$t('statistic.fault'),
            color: '#ff7c7c',
            value: 0
          },
          'standby': {
            name: this.$t('statistic.standby'),
            color: '#4d9bf9',
            value: 0
          }
        },
        chartData: [],
        total: {
          name: this.$t('statistic.totalDevice'),
          value: 0
        },
        isLoading: false
      },
      energy: {
        date: new Date(),
        parameter: [{
          name: this.$t('device.pvPower'),
          value: 'PV_OUTPUT_POWER'
        },
        {
          name: this.$t('device.batteryPower'),
          value: 'BATTERY_ACTIVE_POWER'
        },
        {
          name: this.$t('device.loadPower'),
          value: 'LOAD_ACTIVE_POWER'
        },
        {
          name: this.$t('device.gridPower'),
          value: 'GRID_ACTIVE_POWER'
        }],
        chartData: null,
        isLoading: false
      }
    };
  },
  watch: {
    dialogVisible(val) {
      if(!val) {
        this.closeDialog()
      }
    },
    visible(val) {
      this.dialogVisible = val
    },
    activeProtocol() {
      this.queryDeviceStatus()
      this.queryEnergyData()
    }
  },
  computed: {
    // 协议信息
    protocolInfo() {
      return {
        devcode: this.activeProtocol
      }
    },
    // 设备状态百分比
    devicePercentData() {
      let result = {}, total = this.deviceStatus.total.value
      for(let key in this.deviceStatus.dic) {
        result[key] = total != 0 ? (this.deviceStatus.dic[key].value * 100 / total).toFixed(2) + '%' : '0%'
      }
      return result
    }
  },
  mounted() {
    this.queryProtocol()
  },
  methods: {
    // 关闭弹窗
    closeDialog() {
      this.$emit("update:visible", false);
    },
    // 关闭参数设置弹窗
    closeParamSetting () {
      this.$refs.param.closeSetting()
    },
    // 查询协议列表
    queryProtocol() {
      this.$request.get('queryDeviceDevcodes', { 
        devtype: 2304,
        plantid: this.$store.state.device.pid,
        i18n: this.$lang.currentLang
      }).then(res => {
        if(res.err === 0) {
          let protocols = []
          res.dat.devcode.forEach(item => {
            protocols.push(item.devcode)
          })
          this.protocolList = protocols
          this.activeProtocol = protocols[0]
        }
      })
    },
    // 获取设备状态
    queryDeviceStatus () {
      this.deviceStatus.isLoading = true
      this.$request.get('webQueryDevcodeViewEs', { devcode: this.activeProtocol }).then(res =>{
        let data = []
        if(res.err === 0) {
          for(let key in this.deviceStatus.dic) {
            let info = this.deviceStatus.dic[key], value = res.dat[key] ? res.dat[key] - 0 : 0
            // 存储数据
            info.value = value
            data.push({
              name: info.name,
              value,
              itemStyle: {
                color: info.color
              }
            })
          }
          this.deviceStatus.total.value = res.dat.total
        } else {
          for(let key in this.deviceStatus.dic) {
            this.deviceStatus.dic[key].value = 0
          }
          data = [{
            // this.$t
            name: i18n.t('statistic.totalDevice'),
            value: 0,
            itemStyle: {
              color: '#ccc'
            }
          }]
          this.deviceStatus.total.value = 0
        }
        
        this.deviceStatus.chartData = data
        this.deviceStatus.isLoading = false
      })
    },
    // 获取功率数据
    queryEnergyData() {
      let chartData = {
          category: [],
          data: []
        },
        loadedParam = 0
      this.energy.isLoading = true
      this.energy.parameter.forEach((parameter, index) => {
        let param = {
          devcode: this.activeProtocol,
          i18n: this.$lang.currentLang,
          parameter: parameter.value,
          date: this.$filter.formatDate(this.energy.date, 'yyyy-MM-dd')
        }, category = []
        this.$request.get('querySPDevicesKeyParamOneDay', param).then(res => {
          chartData.data[index] = {
            name: parameter.name,
            value: []
          }
          if (res.err === 0) {
            res.dat.detail.forEach(item => {
              category.push(item.ts)
              chartData.data[index].value.push((item.val - 0).toFixed(2))
            })
          } else {
            category.push(this.$filter.formatDate(this.energy.date, 'yyyy-MM-dd') + ' 00:00:00', this.$filter.formatDate(this.energy.date, 'yyyy-MM-dd') + ' 23:59:59')
            chartData.data[index].value.push('0.00', '0.00')
          }
          if (++ loadedParam === this.energy.parameter.length) {
            chartData.category = category
            this.energy.chartData = chartData
            this.energy.isLoading = false
          }
        })
      })
    },
  }
}
</script>
<style lang="less" scoped>
@import url("../../../../assets/css/mixin.less");
.statisticDialog {
  .statistic {
    height: 85vh;
    display: flex;
    flex-direction: column;
  }
  .title {
    .sc(16px, #333);
  }
  .section {
    // padding: 10px 20px 20px;
    // border:none;
    box-shadow: none;
    .title {
      margin-bottom: 0;
      font-weight: bold;
      padding:5px 0;
    }
  }
  .board .section {
      border:none;
    }
  .tab {
    padding-left: 10px;
    display: flex;
    align-items: center;
    .title {
      margin-bottom: 0;
    }
    &-item {
      padding: 7px 25px;
      border-radius: 20px;
      background: #fff;
      border: 1px solid transparent;
      // box-shadow: 1px 1px 6px @shadowColor;
      margin-left: 20px;
      .sc(14px, #666);
      cursor: pointer;
      &:hover {
        border-color: @themeColor;
        color: @themeColor;
      }
      &.active {
        background: @themeBg;
        color: #fff;
      }
    }
  }
  .board {
    display: flex;
     .title {
      width: 100%;
      font-size: 16px;
      font-weight: 400;
      justify-content: start;
      margin-top: 20px;
      margin-left: 15px;
    }
    .section-param {
      flex: 1;
      margin-right: 20px;
    }
    .status {
      padding:0px 0 50px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .status-chart {
        // width: 160px;
        // height: 160px;
        width: 20vw;
        height: 30vh;
        // margin-right: 25px;
      }
      .status-clause {
        margin-top: 20px;
        display: grid;
        align-content: center;
        align-items: flex-end;
        justify-items: flex-end;
        grid-template-columns: repeat(3, auto);
        grid-template-rows: 1fr 1fr 1fr;
        grid-gap: 10px 30px;
        .status-icon {
          width: 10px;
          height: 10px;
        }
        .item-name {
          justify-self: flex-start;
          .sc(14px, #333);
        }
        .item-value {
          justify-self: flex-end;
          color: #999;
        }
      }
    }
  }
  .energy {
    // margin-top: 20px;
    flex: 1;
    display: grid;
    grid-template-rows: auto 1fr;
    .date {
      width: 200px;
      justify-self: flex-end;
    }
  }
}
</style>